const riot = require('riot');
import '../components/adstats.tag'
riot.tag2('page-adstat', '<adstats></adstats>', '', '', function(opts) {
});

